import { isFromBreakpoint } from '~/breakpoints';
import { publish } from '~/event-bus';
import { debounce } from '~/helpers';
import { HTMLCustomElement } from '~/html-custom-element';

class SiteHeader extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    this.setHeight();

    this.on(
      'resize',
      window,
      debounce(() => {
        this.setHeight();

        if (isFromBreakpoint('medium')) {
          publish('toggle-element-close', { id: 'header-menu' });
        }
      })
    );

    /**
     * Opens the notification hub nested if a newsletter has been submitted.
     */
    const url = new URL(window.location.href);

    if (url.searchParams.get('customer_posted') === 'true') {
      if (url.hash.startsWith('#notification-newsletter-')) {
        const blockId = url.hash.replace('#notification-newsletter-', '');

        setTimeout(() => {
          publish('toggle-element-open', { id: `${blockId}-nested` });
        });
      }
    }
  }

  setHeight() {
    document.body.style.setProperty('--header-height', `${this.getBoundingClientRect().height.toFixed(2)}px`);
  }
}

if (!customElements.get('site-header')) customElements.define('site-header', SiteHeader);
